module.exports = __webpack_public_path__ + "img/individual_support.c208e7e0.jpg";